module.exports = __webpack_public_path__ + "static/media/cattle-drones.33349dc2.jpg";